/**
 * @Copyright 2014-2017 DataVoke, Inc. All rights reserved.
 */
define(function () {
    "use strict";

    var error = {};
    /**
     * Used to create an error message object that hold error information
     * @param viewID  The view ID
     * @param recordID The record ID
     * @param propertyID The property ID
     * @param errorText  The Error Message
     * @param type The type of error (to be used later).
     */
    error.create = function (viewID, recordID, propertyID, errorText, type) {
        var er = {};
        er.viewID = viewID;
        er.recordID = recordID;
        er.propertyID = propertyID;
        er.errorText = errorText;
        er.type = type;
        return er;
    };

    return error;
});
